<template>
  <div class="content">
    <div class="conversation">
      <transition-group
        name="conversation"
        tag="span"
      >
        <template
          v-for="(line, lineIndex) in $props.conversation"
          :key="lineIndex"
        >
          <div class="conversation__line">
            <div class="line__avatar">
              <img :src="GenericAvatar">
            </div>

            <div
              v-if="line.title || line.text || line.actions"
              class="line__text"
            >
              <div
                v-if="line.title"
                class="title-2"
                v-text="line.title"
              />

              <div
                v-if="line.text"
                class="body-2"
                v-html="line.text"
              />

              <template v-if="line.actions">
                <div class="line__actions appearance-extended">
                  <template
                    v-for="(action, actionIndex) in line.actions"
                    :key="actionIndex"
                  >
                    <basic-button
                      size="sm"
                      hierarchy="secondary"
                      :label="action.label"
                      :data-track-as="action.track?.as"
                      :data-track-text="action.track?.text"
                      @click="action.callback"
                    >
                      <template
                        v-if="action.icon"
                        #leading
                      >
                        <the-icon
                          :art="action.icon.art"
                          :name="action.icon.name"
                        />
                      </template>
                    </basic-button>
                  </template>
                </div>
              </template>
            </div>

            <div
              v-if="line.icon"
              class="line__icon"
            >
              <the-icon
                :art="line.icon.art"
                :name="line.icon.name"
                spin
              />
            </div>
          </div>
        </template>
      </transition-group>
    </div>

    <basic-list
      button-icon="trash-can-xmark"
      :button-label="$t('screen.personalData.documents.remove')"
      :entries="$props.file ? [{ disabled: true, name: $props.file.name }] : []"
    />
  </div>

  <div class="footer">
    <basic-button
      hierarchy="tertiary"
      :label="$t('savingsWidget.convo.buttons.restart')"
      @click="$emit('reset')"
    >
      <template #leading>
        <the-icon
          art="solid"
          name="arrow-rotate-left"
        />
      </template>
    </basic-button>

    <basic-button
      v-if="$props.hasDataButton"
      hierarchy="tertiary"
      :label="$t('savingsWidget.convo.buttons.show')"
      @click="$emit('open-modal', { mode: 'readonly' })"
    >
      <template #leading>
        <the-icon
          art="solid"
          name="eye"
        />
      </template>
    </basic-button>
  </div>
</template>

<script setup>

  import {
    BasicButton,
    BasicList,
  } from '@shared/components/Basic'

  import GenericAvatar from '@widgets/assets/generic_avatar.svg'

  // INIT
  defineEmits(['open-modal', 'reset'])
  defineProps({
    conversation: {
      type: Array,
      required: true
    },

    file: {
      type: Object,
      default: () => {}
    },

    hasDataButton: {
      type: Boolean,
      default: false
    }
  })
</script>

<style scoped>
  .conversation-enter-active,
  .conversation-leave-active {
    transition: all var(--duration-long-1) var(--ease-in-out-cubic);
  }
  .conversation-enter-from,
  .conversation-leave-to {
    opacity: 0;
    transform: translateY(-30px);
  }

  .conversation {
    span {
      background-color: var(--surface-ext-a);
      padding: var(--fixed-spacing-fix-04);
      margin: 0 0 var(--dotcom-responsive-spacing-res-m) 0;
      display: flex;
      flex-direction: column;
      gap: var(--fixed-spacing-fix-08);
    }

    .conversation__line {
      display: flex;
      flex-direction: row;
      gap: 16px;

      .line__avatar {}
      .line__text {}
      .line__icon {
        align-self: center;
      }

      .line__actions {
        display: flex;
        flex-direction: column;
        gap: var(--fixed-spacing-fix-04);
        margin: var(--fixed-spacing-fix-08) 0 0 calc(-1 * var(--fixed-spacing-fix-14));
      }
    }
  }

  .footer {
    display: flex;
    flex-direction: column;
    gap: var(--fixed-spacing-fix-04);
    margin: var(--fixed-spacing-fix-08) 0 0 0;
  }
</style>

<style scoped>
  @media (--v-medium) {
    .conversation {
      .conversation__line {
        .line__actions {
          flex-direction: row;
          flex-wrap: wrap;
          margin: var(--fixed-spacing-fix-08) 0 0 0;
        }
      }
    }

    .footer {
      flex-direction: row;
    }
  }
</style>